import { render, staticRenderFns } from "./unificar-cadastro.vue?vue&type=template&id=cc3942d4"
import script from "./unificar-cadastro.vue?vue&type=script&lang=js"
export * from "./unificar-cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports